type SimplifiedPresentationFlagsLoadingState = {
  isFetching: boolean;
  isLoading: boolean;
};

type SimplifiedPresentationFlagsmithSlice = {
  initialised?: boolean;
  loadingState?: SimplifiedPresentationFlagsLoadingState;
};

const isSimplifiedPresentationFlagsReady = (
  flagsmith: SimplifiedPresentationFlagsmithSlice | undefined,
  loadingState?: SimplifiedPresentationFlagsLoadingState | undefined
): boolean => {
  const state = loadingState ?? flagsmith?.loadingState;
  return Boolean(
    flagsmith?.initialised && state && !state.isFetching && !state.isLoading
  );
};

export { isSimplifiedPresentationFlagsReady };
export type {
  SimplifiedPresentationFlagsLoadingState,
  SimplifiedPresentationFlagsmithSlice,
};
